export default {"src":"/_next/static/media/board_custom.0359f0e9.svg","height":606,"width":707,"blurWidth":0,"blurHeight":0};